import type { CardDto } from '@kanban/shared';
import { DragOverlay, defaultDropAnimationSideEffects, type DropAnimation } from '@dnd-kit/core';
import { CardTile } from '../CardTile.js';

/**
 * Preview (SPEC 8.2.3): 1:1-Kopie der Karte, die dem Finger folgt — leicht
 * angehoben, leicht gedreht. Der DragOverlay haengt am Body, nicht in der
 * Spalte; dadurch wird er nicht vom Ueberlauf der Spalte abgeschnitten.
 */
const dropAnimation: DropAnimation = {
  duration: 180,
  easing: 'cubic-bezier(0.2, 0, 0, 1)',
  sideEffects: defaultDropAnimationSideEffects({
    styles: { active: { opacity: '0.4' } },
  }),
};

export function CardDragOverlay({ card }: { card: CardDto | null }) {
  return (
    <DragOverlay dropAnimation={dropAnimation} zIndex={60}>
      {card ? (
        <div
          data-testid="drag-preview"
          style={{
            transform: 'scale(1.03) rotate(2deg)',
            boxShadow: 'var(--shadow-3)',
            borderRadius: 'var(--radius)',
            cursor: 'grabbing',
          }}
        >
          <CardTile card={card} onOpen={() => undefined} />
        </div>
      ) : null}
    </DragOverlay>
  );
}
